import { render, staticRenderFns } from "./BookingTemplateView.vue?vue&type=template&id=7ffd8edf&scoped=true&"
import script from "./BookingTemplateView.vue?vue&type=script&lang=ts&"
export * from "./BookingTemplateView.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTemplateView.vue?vue&type=style&index=0&id=7ffd8edf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd8edf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VIcon})
